export const fmtMoney = (v) => {
  const n = Number(v) || 0;
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1e6) return `${sign}$${(abs / 1e6).toFixed(abs >= 1e7 ? 1 : 2)}M`;
  if (abs >= 1e3) return `${sign}$${(abs / 1e3).toFixed(0)}K`;
  return `${sign}$${abs.toFixed(0)}`;
};

export const fmtFull = (v) => {
  const n = Number(v) || 0;
  return `${n < 0 ? "-" : ""}$${Math.abs(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
};

export const fmtPct = (v, dp = 0) => `${(Number(v) || 0).toFixed(dp)}%`;

export const fmtNum = (v, dp = 1) => (Number(v) || 0).toLocaleString("en-US", { maximumFractionDigits: dp });

export const fmtValue = (v, format) => {
  if (format === "currency") return fmtMoney(v);
  if (format === "percent") return fmtPct(v, 1);
  return fmtNum(v, 0);
};
